import { cn } from '@/lib/utils';

interface DetailsLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Nagłówek ekranu — pełna szerokość, nad obiema kolumnami. */
  header: React.ReactNode;
  /**
   * Panel boczny 320 px — stan rekordu, powiązania, historia. Pominięty albo
   * pusty znika razem ze swoją kolumną, zamiast zostawiać dziurę w układzie.
   */
  sidebar?: React.ReactNode;
  /**
   * Pasek domykający treść (np. „Wartość zmian”) — szerokość kolumny treści,
   * więc siedzi w niej, a nie pod całym ekranem.
   */
  bottomBar?: React.ReactNode;
}

/**
 * Ekran jednego rekordu: nagłówek, treść i panel boczny. Trzyma proporcje
 * z projektu — 1356 px całości, 1020 px kolumny treści, 320 px panelu
 * i 16 px przerwy.
 *
 * Odstęp od krawędzi okna daje layout aplikacji (`AppLayout` ma `p-6`),
 * dlatego szkielet sam nie dokłada paddingu.
 */
const DetailsLayout = ({
  header,
  sidebar,
  bottomBar,
  children,
  className,
  ...props
}: DetailsLayoutProps) => (
  <div
    className={cn('flex w-full max-w-[1356px] flex-col gap-4', className)}
    {...props}
  >
    {header}

    <div className="flex flex-wrap items-start gap-4">
      {/* Minima kolumn dopiero od `md` — niżej okno bywa węższe niż one same
          i strona wyjeżdżałaby w poziomie. */}
      <div className="grow-2 flex-3 flex min-w-0 max-w-[1020px] flex-col gap-4 md:min-w-[460px]">
        {children}
        {bottomBar}
      </div>

      {sidebar && (
        <aside className="min-w-full flex-1 md:min-w-[320px]">{sidebar}</aside>
      )}
    </div>
  </div>
);

export default DetailsLayout;
